import moment from "moment";
import React, { useRef, useEffect, useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";

function useOutsideAlerter(ref) {
  const [showAction, setShowAction] = useState(false);
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowAction(false);
      } else {
        setShowAction(true);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  return showAction;
}
export default function DaySchedule({
  day,
  modal,
  setModal,
  setShiftDate,
  setActiveDate,
}) {
  const wrapperRef = useRef(null);
  let showAction = useOutsideAlerter(wrapperRef);
  return (
    <div
      ref={wrapperRef}
      className={`wrap single-day ${day.shifts.length && "active"}`}
    >
      <p className="day_name">{day.name}</p>

      {day.shifts.length ? (
        <div className="orders">
          {day.shifts.map((shift) => {
            return (
              <span
                onClick={() => {
                  setModal(true);
                  setShiftDate(day.full_date);
                  setActiveDate(day.full_date);
                }}
              >
                {moment(shift.start_datetime).format("HH:mm")}-
                {moment(shift.end_datetime).format("HH:mm")} -{" "}
                {shift.shipments_count} orders -{" "}
                {shift.registered_carriers.length}/{shift.desired_carriers}{" "}
                couriers
              </span>
            );
          })}
        </div>
      ) : (
        <p className="no-shift">NO SHIFTS ASSIGNED</p>
      )}
      <div className="dropdown">
        {day.shifts.length ? (
          <>
            <BsThreeDotsVertical onClick={() => setActiveDate(day.full_date)} />
            {showAction && (
              <div className="actions">
                <button
                  onClick={() => {
                    setModal(true);
                    setShiftDate(day.full_date);
                    setActiveDate(day.full_date);
                  }}
                >
                  Add/Edit
                </button>
              </div>
            )}
          </>
        ) : (
          <>
            <div
              className="add-schedule d-flex justify-content-between"
              onClick={() => {
                setModal(true);
                setShiftDate(day.full_date);
                setActiveDate(day.full_date);
              }}
            >
              <p className="">Add schedule </p>
              <AiOutlinePlusCircle />
            </div>
          </>
        )}
      </div>
      {/* <p className="day_number">{moment(x).format("D")}</p> */}
    </div>
  );
}
